module.exports = __webpack_public_path__ + "img/IMG_8999.ec0b3a7b.jpg";